import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { AuthService } from '../../services/auth.service';
import { UserStateService } from '../../services/users/user-state.service';

@Component({
  selector: 'app-token-expiration-modal',
  templateUrl: './token-expiration-modal.component.html',
})
export class TokenExpirationModalComponent implements OnDestroy {
  isLoading = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private userStateService: UserStateService,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  async logout() {
    this.activeModal.close();
    await this.authService.logout();
  }

  refreshToken() {
    this.isLoading = true;

    const creds = this.userStateService.userCredentials;

    this.subscriptions.add(
      this.authService.login(creds).subscribe({
        next: (_token) => {
          this.isLoading = false;
          this.activeModal.close();
        },
        error: () => {
          this.isLoading = false;
        },
      }),
    );
  }
}
